import React from 'react';
import { connect } from 'react-redux';
import { find, isEqual, capitalize, cloneDeep, get, map } from 'lodash';
import Box from '../../common/Box';
import vendorsArray from '../../widgets/filter/enums/vendors';
import ReactTable from 'react-table';
import ModeSelect from '../../common/ModeSelect';
import CSV from '../../../helpers/CSVExport';
import ReactSelect from '../../common/ReactSelect';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';

import { youtubeActions } from '../../../data/actions/youtube';
import { youtubeSourcesSettings } from './YoutubeSources/Settings';

var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');

class YoutubeSources extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			mode: 'table',
	        vendor: 0,
	        pieSources: 'views',
			sorted: [{id: 'total', desc: true}]
		}
		this.exportToCsv = this.exportToCsv.bind(this);
		this.setVendor = this.setVendor.bind(this);
		this.setChartMode = this.setChartMode.bind(this);
		this.setPieSources = this.setPieSources.bind(this);
	}

    exportToCsv(){
        const tableData = this.props.youtube.sourceStats.table,
            filename = CSV.CSVHeader('youtube_sources', '', this.props.filter.global);
        
        return CSV.CSVExport(tableData, {filename}, 'youtube_sources');
    }
    
    setVendor({vend_id}) {
        this.setState({
            vendor: vend_id
        });
    }
    
    setPieSources({value}) {
        this.setState({
            pieSources: value
        });
    }
	
	setChartMode(mode){
		this.setState({mode});
		
		const { modeChange } = this.props;
		if(typeof modeChange == 'function')
			modeChange(mode);
			
		if(mode == 'line') {
			this.props.getYoutubeSourcesTimeseries(this.props.filtered, this.state.dateGroup);
		}
	}

	
	renderToolbar(data = []){
		const options = [
			{icon: pieSvg, value: 'pie', label: "Donut Chart"},
			{icon: barSvg, value: 'bar', label: "Bar Chart"},
			{icon: tableSvg, value: 'table', label: "Table"},
		];
		
		let toolbar = [];

		toolbar.push(<div key="wrapper" className="ibox-action-holder">
			<div className="ibox-actions">
				<div className="ibox-icon-holder mode-select">
					<ModeSelect options={options} selected={this.state.mode} onChange={this.setChartMode} isSearchable={ false } />
				</div>
				<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
			</div>
		</div>)

		return toolbar;
	}
	
   renderToolbarPie(data = []){
        let toolbar = [];
        let vendors = [{label:'Views', value: 'views'}, {label:'Creates', value: 'creates'}];

        const vendorValue = vendors.find(vendor=>vendor.value == this.state.pieSources);
		
		
		const options = [
			{icon: pieSvg, value: 'pie', label: "Donut Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"},
			
		];
		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
			<div className="ibox-icon-holder mode-select">
				<ModeSelect options={options} selected={this.state.mode} onChange={this.setChartMode} isSearchable={ false } />
			</div>
        	<div className="ibox-actions">
            	<ReactSelect value={vendorValue} options={vendors} onChange={this.setPieSources} className="single-select"/>
        	</div>
        </div>)

        return toolbar;
    }

	
	
	componentDidMount() {
		const { mode } = this.state;
		if(mode == 'line')
			this.props.getYoutubeSourcesTimeseries(this.props.filtered, this.state.sorted);
		else
			this.props.getYoutubeSources(this.props.filtered, this.state.sorted);
	}
	
	componentWillReceiveProps(nextProps){
		const { mode } = this.state;
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
				if(mode == 'line')
					this.props.getYoutubeSourcesTimeseries(nextProps.filtered, this.state.sorted);
				else
					this.props.getYoutubeSources(nextProps.filtered, this.state.sorted);
			}                
		}
		if(nextProps.filtered && !isEqual(nextProps.filtered, this.props.filtered, this.state.sorted)) {
			if(mode == 'line')
				this.props.getYoutubeSourcesTimeseries(nextProps.filtered, this.state.sorted);
			else
				this.props.getYoutubeSources(nextProps.filtered);
		} 
	}
	
	render (){  
		const {sourceStats , sourceStatsLoading} = this.props.youtube,
			widgetTitle = `Top YouTube Sources`;
		const { mode } = this.state;
		
	      let { shadowChartProps } = this.props;
	        if(shadowChartProps){
	            shadowChartProps.shadowChart = true;
	        }
			
		const tableData = get(sourceStats, 'table');
		const barData = get(sourceStats, 'timeseries');	     
		const pieData = get(sourceStats, 'pie');


		return <React.Fragment>
    		<Box title={widgetTitle} toolbar={this.renderToolbar()} spinnerEnabled={sourceStatsLoading} >
                {(mode == 'table' && tableData) && <ReactTable
                    className="simple-table"
                    data={tableData}
                    columns={youtubeSourcesSettings.settingsForTable()}
                    showPagination={false}
                    defaultSortDesc={true}
                    defaultSorted={this.state.sorted}
                    pageSize={(tableData && tableData.length ) ? tableData.length : 10}                
                />}
				
				{(mode == 'bar' && barData ) && <div className="chart-block">
					<StackedBarChart data={barData} {...shadowChartProps} />
				</div>}
				
				{(mode == 'pie' && pieData ) && <div className="chart-block">
					<DoughnutChart data={pieData} {...shadowChartProps} />
				</div>}


    		</Box>
		</React.Fragment>;
	}
}

function mapStateToProps(state) {
	return {
		youtube: state.youtube,
		filter: state.filter,
	} 
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		getYoutubeSources: (filtered, sorted, dateGroup) => {
			return dispatch(youtubeActions.getSourceStats(filtered, sorted, dateGroup));
		} ,
		getYoutubeSourcesTimeseries: (filtered, dateGroup) => {
			return dispatch(youtubeActions.getSourceTimeseries(filtered, dateGroup));
		} 
	} 
}



export default connect(mapStateToProps, mapDispatchToProps)(YoutubeSources);